import { Modal } from "@twinkltech/curriculum-architect-component-library";
import { UnitPreview } from "@twinkltech/curriculum-architect-domain-hooks";
import { Button, Text } from "@twinkltech/web-ui";

import { LoadingModal } from "@/pages/LoadingModal/LoadingModal";

import { PreviewUnitContent } from "../PreviewUnitContent/PreviewUnitContent";

export const PreviewUnitModal = ({
  error,
  isLoading,
  onClose,
  unit,
  ...props
}: {
  unitId: string;
  isLoading: boolean;
  error?: Error | null;
  unit?: UnitPreview;
} & Omit<React.ComponentProps<typeof Modal>, "children">) => {
  if (isLoading) {
    return (
      <LoadingModal
        open
        className="px-4 py-2"
        width="md"
        onClose={() => onClose(false)}
      />
    );
  } else {
    return (
      <Modal
        {...props}
        className="px-4 py-2 max-h-[95vh]"
        width="md"
        onClose={onClose}
      >
        <Modal.Header>
          <Text variant="2xl-medium">Unit Preview</Text>
        </Modal.Header>

        <Modal.Body
          aria-label="Unit Preview Content"
          className="overflow-y-auto"
          role="region"
        >
          {error ? (
            `There was an error loading the unit preview: ${error.message} `
          ) : !unit ? (
            "No unit preview data available."
          ) : (
            <PreviewUnitContent unit={unit} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={() => onClose(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
};
